import React, { useContext, useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";
import {
  ListItemIcon,
  ListItemText,
  MenuList,
  MenuItem,
  Typography
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import VpnKey from "@mui/icons-material/VpnKey";
import Home from "@mui/icons-material/Home";
import ImageIcon from "@mui/icons-material/Image";
import PhotoSizeSelectLargeIcon from "@mui/icons-material/PhotoSizeSelectLarge";

import SettingsIcon from "@mui/icons-material/Settings";
import TvIcon from "@mui/icons-material/Tv";
import DescriptionIcon from "@mui/icons-material/Description";
import LabelIcon from "@mui/icons-material/Label";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import PolicyIcon from "@mui/icons-material/Policy";
import LooksIcon from "@mui/icons-material/Looks";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";

import { Link } from "react-router-dom";

import RefresherContext from "../../../contexts/Shared/RefresherProvider/RefresherContext";
import HttpContext from "../../../contexts/HTTP/HttpContext";
import AuthContext from "../../../contexts/Auth/AuthContext";
import MobileContext from "../../../contexts/Mobile/MobileContext";

let env = require("../../../env.js");

function Navigation(props) {
  const theme = useTheme();
  const { get } = useContext(HttpContext);
  const { authenticated } = useContext(AuthContext);
  const { isMobile } = useContext(MobileContext);
  const { requiresRefresh } = useContext(RefresherContext);

  const { visible, handleClose } = props;

  const [showCharity, setShowCharity] = useState("");

  useEffect(() => {
    //requiresRefresh is used to refresh the side menu, so charities will show/hide
  }, [requiresRefresh]);

  const handleLinkClick = () => {
    if (isMobile) {
      handleClose();
    }
  };

  const loadFromAdminTheme = async () => {
    const res = await get("/kiosk/getAdminTheme");

    if (res.status == 200) {
      setShowCharity(res.data.theme.enableCharities);
      console.log("[DEBUG] Dashboard 200", res);
    }
  };
  loadFromAdminTheme();

  return (
    <div
      style={{
        width: visible ? "300px" : 0,
        minWidth: visible ? "300px" : 0,
        maxWidth: visible ? "300px" : 0,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        transition: "0.3s",
        overflow: "hidden"
      }}
    >
      {/* <Typography
        style={{ fontWeight: 500, margin: theme.spacing(2), marginBottom: 0 }}
      >
        General
      </Typography>
      <MenuList style={{ marginLeft: theme.spacing(2) }}>
        <Link
          to="/dashboard/home"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <Home />
            </ListItemIcon>
            <ListItemText>Home</ListItemText>
          </MenuItem>
        </Link>
      </MenuList>
      <Typography
        style={{ fontWeight: 500, margin: theme.spacing(2), marginBottom: 0 }}
      >
        Other
      </Typography> */}
      <MenuList style={{ marginLeft: theme.spacing(2) }}>
        {authenticated.roles.includes("admin") && (
          <Link
            to="/dashboard/admin"
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={handleLinkClick}
          >
            <MenuItem>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText>Admin</ListItemText>
            </MenuItem>
          </Link>
        )}

        <Link
          to="/dashboard/kiosks"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <TvIcon />
            </ListItemIcon>
            <ListItemText>Kiosks</ListItemText>
          </MenuItem>
        </Link>
        {showCharity && (
          <>
            <Link
              to="/dashboard/Charities"
              style={{ textDecoration: "none", color: "inherit" }}
              onClick={handleLinkClick}
            >
              <MenuItem>
                <ListItemIcon>
                  <VolunteerActivismIcon />
                </ListItemIcon>
                <ListItemText>Charities</ListItemText>
              </MenuItem>
            </Link>
          </>
        )}
        <Link
          to="/dashboard/BagtagLogs"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <LabelIcon />
            </ListItemIcon>
            <ListItemText>Bagtags</ListItemText>
          </MenuItem>
        </Link>

        <Link
          to="/dashboard/Users"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <ListItemText>Users</ListItemText>
          </MenuItem>
        </Link>

        <Link
          to="/dashboard/ErrorLogs"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <DescriptionIcon />
            </ListItemIcon>
            <ListItemText>Error Logs</ListItemText>
          </MenuItem>
        </Link>

        <Link
          to="/dashboard/ActivityLogs"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <PolicyIcon />
            </ListItemIcon>
            <ListItemText>Activity Logs</ListItemText>
          </MenuItem>
        </Link>

        {/* <Link
          to="/dashboard/SocketMonitor"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText>Socket Monitor</ListItemText>
          </MenuItem>
        </Link> */}

        <Link
          to="/dashboard/SocketMonitorAPI"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <DeviceHubIcon />
            </ListItemIcon>
            <ListItemText>Socket Monitor</ListItemText>
          </MenuItem>
        </Link>

        <Link
          to="/dashboard/KioskTheme"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <LooksIcon />
            </ListItemIcon>
            <ListItemText>Kiosk Theme</ListItemText>
          </MenuItem>
        </Link>

        <Link
          to="/dashboard/ServerSettings"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText>Server Settings</ListItemText>
          </MenuItem>
        </Link>

        {/* <Link
          to="/dashboard/AdsSettings"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <AdUnitsIcon />
            </ListItemIcon>
            <ListItemText>Advertisements</ListItemText>
          </MenuItem>
        </Link> */}

        {/* Hidden for now until we start using this for Ad/branding configurations */}
        {/* <Link
          to="/dashboard/Configuration"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText>Configuration</ListItemText>
          </MenuItem>
        </Link> */}
        {/* <Link
          to="/dashboard/api"
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleLinkClick}
        >
          <MenuItem>
            <ListItemIcon>
              <VpnKey />
            </ListItemIcon>
            <ListItemText>API Keys</ListItemText>
          </MenuItem>
        </Link>

        {JSON.parse(env.REACT_APP_API_KEYS_ENABLED) && (
          <Link
            to="/dashboard/api"
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={handleLinkClick}
          >
            <MenuItem>
              <ListItemIcon>
                <VpnKey />
              </ListItemIcon>
              <ListItemText>API Keys</ListItemText>
            </MenuItem>
          </Link>
        )} */}
      </MenuList>
    </div>
  );
}

export default Navigation;
